import Product from "../Shared/Product";
import { ThemeContext } from "../../Contexts/ThemeContext";
import { useContext } from "react";
import "./MostFavorite.css";
import { Link } from "react-router-dom";

const MostFavorite = () => {
  const { favProducts } = useContext(ThemeContext);
  const products = favProducts?.slice(0, 4);

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "ItemList",
    name: "Most Loved Skincare & Beauty Products",
    description:
      "Explore our most loved skincare and beauty products including face washes, serums, moisturizers, and more.",
    itemListElement: products?.map((product, index) => ({
      "@type": "Product",
      position: index + 1,
      name: product?.name,
      url: `https://earthbeautyandyou.com/product/${product?.slug}`,
      image: product?.images?.[0]?.src,
      offers: {
        "@type": "Offer",
        priceCurrency: "BDT",
        price: product?.on_sale ? product?.sale_price : product?.regular_price,
        availability:
          product?.stock_quantity > 0
            ? "https://schema.org/InStock"
            : "https://schema.org/OutOfStock",
      },
    })),
  };

  return (
    <section
      className="most-favorite py-16 md:py-20 overflow-hidden"
      aria-label="Most Loved Skincare & Beauty Products"
    >
      <script type="application/ld+json">{JSON.stringify(structuredData)}</script>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        {/* Section Header */}
        <div className="text-center mb-10">
          <span className="inline-block text-xs font-semibold tracking-[0.2em] uppercase text-[#729B7F] mb-3">
            Customer Favourites
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3">
            Most Loved Products
          </h2>
          <div className="w-14 h-0.5 bg-gradient-to-r from-[#729B7F] to-[#abcacb] mx-auto mb-4" />
          <p className="text-gray-500 text-sm md:text-base max-w-xl mx-auto">
            Discover the best-selling picks chosen by our customers — from
            nourishing face washes to hydrating creams.
          </p>
        </div>

        {/* Product Grid */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
          {products?.length > 0
            ? products.map((product) => (
                <Product key={product?._id} product={product} />
              ))
            : Array.from({ length: 4 }).map((_, i) => (
                <div
                  key={i}
                  className="rounded-xl bg-gray-100 animate-pulse h-80"
                />
              ))}
        </div>

        {/* CTA */}
        {/* <div className="mt-12 text-center">
          <Link
            to="/product-category/face wash"
            className="inline-flex items-center gap-2 bg-[#729B7F] hover:bg-[#6ab558] text-white font-semibold px-8 py-3 rounded-full transition-all duration-200 shadow-md hover:shadow-lg hover:-translate-y-0.5"
            title="Shop all face wash products"
          >
            Shop All Face Wash
            <svg
              className="w-4 h-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9 5l7 7-7 7"
              />
            </svg>
          </Link>
        </div> */}
      </div>
    </section>
  );
};

export default MostFavorite;




// import Product from "../Shared/Product";
// import { ThemeContext } from "../../Contexts/ThemeContext";
// import { useContext } from "react";
// import "./MostFavorite.css";
// import { Link } from "react-router-dom";

// const MostFavorite = () => {
//   const { favProducts } = useContext(ThemeContext);
//   const products = favProducts?.slice(0, 4);

//   // ✅ JSON-LD structured data for Most Loved Products
//   const structuredData = {
//     "@context": "https://schema.org",
//     "@type": "ItemList",
//     name: "Most Loved Skincare & Beauty Products",
//     description:
//       "Explore our most loved skincare and beauty products including face washes, serums, moisturizers, and more.",
//     itemListElement: products?.map((product, index) => ({
//       "@type": "Product",
//       position: index + 1,
//       name: product?.name,
//       url: `https://earthbeautyandyou.com/product/${product?.slug}`,
//       image: product?.images?.[0]?.src,
//       offers: {
//         "@type": "Offer",
//         priceCurrency: "BDT",
//         price: product?.on_sale ? product?.sale_price : product?.regular_price,
//         availability:
//           product?.stock_quantity > 0
//             ? "https://schema.org/InStock"
//             : "https://schema.org/OutOfStock",
//       },
//     })),
//   };

//   return (
//     <section
//       className="overflow-hidden "
//       aria-label="Most Loved Skincare & Beauty Products"
//     >
//       {/* ✅ Structured Data */}
//       <script type="application/ld+json">
//         {JSON.stringify(structuredData)}
//       </script>

//       <div className="flex flex-col  container mx-auto px-4 sm:px-6 lg:px-0  border-gray-300">
//         {/* ✅ SEO-friendly Heading */}
//         <h3 className="text-center text-2xl sm:text-3xl font-bold text-accent mt-16">
//           Most Loved Skincare Products in Bangladesh
//         </h3>

//         {/* ✅ Short intro for SEO context */}
//         <p className="text-center text-secondary text-opacity-80 mt-4 mb-6 max-w-2xl">
//           Discover the best-selling and most loved skincare products chosen by
//           our customers. From nourishing face washes to hydrating creams, these
//           are the top-rated picks you’ll love.
//         </p>

//         {/* <div className="w-[130px] mx-auto h-1 bg-accent my-6 mb-10"></div> */}

//         {/* ✅ Product Grid */}
//         <div className="grid grid-cols-2 sm:grid-cols-2 lg:gap-6 lg:grid-cols-3 xl:grid-cols-4 ffffeatured-collections">
//           {products?.map((product) => (
//             <Product key={product?._id} product={product} />
//           ))}
//         </div>
//         {/* ✅ More descriptive link text */}
//         <Link
//           to="/product-category/face wash"
//           className="text-white mx-auto bg-accent px-10 rounded sm:mt-20 py-2 hover:bg-secondary ease-in-out duration-200 font-bold sm:my-10"
//           title="View more new arrival products"
//         >
//           All Face Wash
//         </Link>
//       </div>
//     </section>
//   );
// };

// export default MostFavorite;
